import React, { Component } from 'react';
import accessories1 from '../assets/accessories1.png';
import logo2 from '../assets/logo2.png';

class ShopAccessories extends Component {
  render() {
    return (
      <div className="ShopAccessories">
        <h1>Thai-Aikikai Shop's Accessories</h1>

        <img className="accessories1" src={accessories1} alt="accessories1" />
        <h2>Key Holder1</h2>
        <br />

        <div>
          please click to order
        </div>
        <br />

        <div>Powered by</div>
        <img className="logo2" src={logo2} alt="New Wave Consulting Group" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default ShopAccessories;
